<kendo-splitter orientation="horizontal" [style.height]="'100%'">
  <kendo-splitter-pane [collapsible]="true" size="33%">
    <kendo-splitter orientation="vertical">
      <kendo-splitter-pane size="50%">
        <div class="pane-content">
          <div class="d-flex flex-column">
            <form class="form-inline">
              <span style="display:flex; flex-grow:1">
                <label class="px-1 my-1">Function:</label>
                <kendo-dropdownlist
                  #functionDropdownList
                  textField="Description"
                  valueField="FunctionId"
                  [data]="stdCfgSharedServiceService.IFunctionDtos"
                  (valueChange)="onValueChange($event)"
                  style="flex-grow:1"
                  [className]="'my-1 w-60'"></kendo-dropdownlist>
              </span>
              <button type="button" style="margin-left:5px;" kendoButton [disabled]="selectedFunction === null || selectedFunction === undefined"
                themeColor="primary" [svgIcon]="icons.plusCircle" (click)="addNewItem()">
                Create New
              </button>
              <button type="button" style="margin-left:5px;" kendoButton [disabled]="selectedStdConfig === null || selectedStdConfig === undefined"
                themeColor="primary" [svgIcon]="icons.plusCircle" (click)="copyStdConfig()">
                Create Copy
              </button>
            </form>
          </div>
        </div>
        <div class="pane-content" style="height:calc(100% - 40px)">
          <app-stg-cfg-details></app-stg-cfg-details>
        </div>
      </kendo-splitter-pane>
      <kendo-splitter-pane [collapsible]="true">
        <div class="pane-content" style="height:calc(100% - 10px)">
          <app-stg-cfg-items></app-stg-cfg-items>
        </div>
      </kendo-splitter-pane>
    </kendo-splitter>
  </kendo-splitter-pane>
  <kendo-splitter-pane [scrollable]="false" style="height:100%">
    <kendo-splitter orientation="vertical">
      <kendo-splitter-pane [scrollable]="false">
        <div class="pane-content" style="height:100%">
          <app-stg-cfg-pad></app-stg-cfg-pad>
        </div>
      </kendo-splitter-pane>
    </kendo-splitter>
  </kendo-splitter-pane>
</kendo-splitter>

@if (dialogOpened) {
<kendo-dialog
  title="Please Confirm"
  (close)="confirmCancel()"
  [width]="450">
  <p style="margin: 30px; text-align: center;">
    You have unsaved changes.
  </p>
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="confirmSave()" themeColor="primary">
      Save
    </button>
    <button type="button" kendoButton (click)="confirmDontSave()">
      Don't Save
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}